export const DEVELOPMENT_ACTIVITY_MODEL_COLORS = {
    applied: "#64aad8",
    approved: "#66cca2",
    underConstruction: "#ffeaad"
};
